(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./ajax/appRequest", "./utils/helpers"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./ajax/appRequest"), require("./utils/helpers"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.appRequest, global.helpers);
    global.actions = mod.exports;
  }
})(this, function (exports, _appRequest, _helpers) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.GET_DESCRIPTORS = exports.GET_CONTENT = exports.GET_CHILD_BY_ID = exports.GET_SEARCH_CHILDREN = exports.GET_RANDOM_CHILDREN = exports.GET_CHILDREN = exports.SET_DESCRIPTORS = exports.UPDATE_SEARCH_METHOD = exports.UPDATE_STATUS = exports.SET_CHILD = exports.SET_CHILDREN = exports.SET_CHILD_IDS = exports.SET_SUBMISSIONS_RESPONSE = exports.CLEAR_SUBMISSION = exports.SET_SUBMISSIONS_REQUEST = undefined;
  exports.submissionRequest = submissionRequest;
  exports.submissionResponse = submissionResponse;
  exports.clearSubmission = clearSubmission;
  exports.setChildIds = setChildIds;
  exports.setChildren = setChildren;
  exports.setChild = setChild;
  exports.statusUpdater = statusUpdater;
  exports.searchMethodUpdater = searchMethodUpdater;
  exports.setDescriptors = setDescriptors;
  exports.getChildren = getChildren;
  exports.getRandomChildren = getRandomChildren;
  exports.getSearchChildren = getSearchChildren;
  exports.getChildById = getChildById;
  exports.getChildStoryById = getChildStoryById;
  exports.getContent = getContent;
  exports.getDescriptors = getDescriptors;

  var _appRequest2 = _interopRequireDefault(_appRequest);

  var _helpers2 = _interopRequireDefault(_helpers);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  // Action Type
  var SET_SUBMISSIONS_REQUEST = exports.SET_SUBMISSIONS_REQUEST = "SET_SUBMISSIONS_REQUEST";

  // Action Creator
  function submissionRequest(key, data) {
    //console.log("submissionRequest", data);
    return {
      type: SET_SUBMISSIONS_REQUEST,
      data: data,
      key: key
    };
  }

  var CLEAR_SUBMISSION = exports.CLEAR_SUBMISSION = "CLEAR_SUBMISSION";

  // Action Type
  var SET_SUBMISSIONS_RESPONSE = exports.SET_SUBMISSIONS_RESPONSE = "SET_SUBMISSIONS_RESPONSE";

  // Action Creator
  function submissionResponse(key, data) {
    var responseData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var error = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    //console.log('submissionRequest', details);
    return {
      type: SET_SUBMISSIONS_RESPONSE,
      data: data,
      responseData: responseData,
      key: key,
      error: error
    };
  }
  // Action Creator
  function clearSubmission(key, data) {
    //console.log('submissionRequest', details);
    return {
      type: CLEAR_SUBMISSION,
      data: data,
      key: key
    };
  }
  // Action Type
  var SET_CHILD_IDS = exports.SET_CHILD_IDS = "SET_CHILD_IDS";

  // Action Creator
  function setChildIds(data, key) {
    var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    //console.log('submissionRequest', details);
    return {
      type: SET_CHILD_IDS,
      payload: data,
      key: key,
      error: error
    };
  }
  // Action Type
  var SET_CHILDREN = exports.SET_CHILDREN = "SET_CHILDREN";

  // Action Creator
  function setChildren(data) {
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return {
      type: SET_CHILDREN,
      payload: data,
      error: error
    };
  }
  // Action Type
  var SET_CHILD = exports.SET_CHILD = "SET_CHILD";

  // Action Creator
  function setChild(data, key) {
    var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    //console.log('submissionRequest', details);
    return {
      type: SET_CHILD,
      payload: data,
      key: key,
      error: error
    };
  }
  // Action Type
  var UPDATE_STATUS = exports.UPDATE_STATUS = "UPDATE_STATUS";
  // Action Creator
  function statusUpdater(status) {
    return {
      type: UPDATE_STATUS,
      payload: status
    };
  }
  // Action Type
  var UPDATE_SEARCH_METHOD = exports.UPDATE_SEARCH_METHOD = "UPDATE_SEARCH_METHOD";
  // Action Creator
  function searchMethodUpdater(method) {
    return {
      type: UPDATE_SEARCH_METHOD,
      payload: method
    };
  }
  // Action Type
  var SET_DESCRIPTORS = exports.SET_DESCRIPTORS = "SET_DESCRIPTORS";

  // Action Creator
  function setDescriptors(data) {
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    //console.log('submissionRequest', details);
    return {
      type: SET_DESCRIPTORS,
      data: data,
      error: error
    };
  }
  // Action Type
  var GET_CHILDREN = exports.GET_CHILDREN = "GET_CHILDREN";
  // Action Creator
  function getChildren(take, params) {
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    // console.log("search children params", params);
    // console.log("search children take", take);
    //const urlParams = params || helpers.getParams();

    var sanitizedParams = _helpers2.default.sanitizeParams(_extends({}, params), "searchTerm");
    switch (Object.keys(sanitizedParams).length > 0 && sanitizedParams.constructor === Object) {
      case true:
        var searchParams = {
          searchCriteriaList: [sanitizedParams],
          sortOrder: 0,
          take: take
        };
        var dispatchSearch = function dispatchSearch(dispatch) {
          dispatch(statusUpdater("EDITING"));
          dispatch(searchMethodUpdater("search"));
          dispatch(getSearchChildren(searchParams, callback));
        };
        return function (dispatch) {
          dispatch(dispatchSearch);
          return Promise.resolve();
        };
        break;
      default:
        var dispatchRandom = function dispatchRandom(dispatch) {
          dispatch(statusUpdater("EDITING"));
          dispatch(searchMethodUpdater("random"));
          dispatch(getRandomChildren(take, callback));
        };
        return function (dispatch) {
          dispatch(dispatchRandom);
          return Promise.resolve();
        };
        break;
    }
  }
  // Action Type
  var GET_RANDOM_CHILDREN = exports.GET_RANDOM_CHILDREN = "GET_RANDOM_CHILDREN";
  // Action Creator
  function getRandomChildren(rcData) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    //console.log("action take: ", rcData);
    return function (dispatch) {
      dispatch(statusUpdater("EDITING"));
      dispatch(submissionRequest("children", rcData));
      return _appRequest2.default.getRandomChild(rcData).then(function (resp) {
        if (resp.success != true || !resp.success) {
          //console.log("response from action error: ", resp);
          return Promise.reject(resp);
        } else {
          //console.log("response from action then: ", resp.data.items);
          //store child ids in array so they can be referenced by ID if needed
          var childItems = resp.data.items;
          //store child ids in array so they can be referenced by ID if needed
          var childIdsList = _helpers2.default.childIdsArray(childItems, "identifier");
          //store response keyed by child ID
          //const childList = helpers.arrayToObject(childItems, "identifier");
          var childList = _helpers2.default.searchTermKeyed(childItems, "identifier");
          var metaData = {
            currentCount: resp.data.currentCount,
            totalCount: resp.data.totalCount
          };
          var dispatcher = function dispatcher(dispatch) {
            dispatch(submissionResponse("children", childIdsList, metaData, false));
            dispatch(setChildren(childList.data));
            dispatch(setChildIds(childIdsList, "randomSearch"));
            dispatch(statusUpdater("COMPLETE"));
            callback(resp);
            //return Promise.resolve();
          };
          return dispatch(dispatcher);
        }
      }).catch(function (resp) {
        dispatch(submissionResponse("children", resp, null, true));
        dispatch(statusUpdater("ERROR"));
        callback(resp);
        //return Promise.resolve();
      });
    };
  }

  // Action Type
  var GET_SEARCH_CHILDREN = exports.GET_SEARCH_CHILDREN = "GET_SEARCH_CHILDREN";
  // Action Creator
  function getSearchChildren(params) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    return function (dispatch) {
      dispatch(statusUpdater("EDITING"));
      dispatch(submissionRequest("children", params));
      return _appRequest2.default.getSearchChildren(params).then(function (resp) {
        if (resp.success != true || !resp.success) {
          // console.log("response from action: ", resp);
          return Promise.reject(resp);
        }
        var childItems = resp.data.items;
        //store child ids in array so they can be referenced by ID if needed
        var childIdsList = _helpers2.default.childIdsArray(childItems, "identifier");
        //store response keyed by search query term.
        var childList = _helpers2.default.searchTermKeyed(childItems, "identifier", params.searchCriteriaList[0]);
        var metaData = {
          currentCount: resp.data.currentCount,
          totalCount: resp.data.totalCount
        };
        // console.log("childList by Id:", childList);
        var dispatcher = function dispatcher(dispatch) {
          dispatch(submissionResponse("children", childIdsList, metaData, false));
          dispatch(setChildren(childList.data));
          dispatch(setChildIds(childIdsList, childList.queryString));
          dispatch(statusUpdater("COMPLETE"));
          callback(resp);
          //return Promise.resolve();
        };
        return dispatch(dispatcher);
      }).catch(function (resp) {
        dispatch(submissionResponse("children", resp, null, true));
        dispatch(statusUpdater("ERROR"));
        callback(resp);
        // return Promise.resolve();
      });
    };
  }
  // Action Type
  var GET_CHILD_BY_ID = exports.GET_CHILD_BY_ID = "GET_CHILD_BY_ID";
  // Action Creator
  function getChildById(data) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    // console.log("child Id: ", data);
    return function (dispatch) {
      dispatch(statusUpdater("EDITING"));
      dispatch(submissionRequest("child", data));
      return _appRequest2.default.getChildById(data).then(function (resp) {
        if (resp.success != true || !resp.success) {
          // console.log("response from action error: ", resp);
          return Promise.reject(resp);
        } else {
          var childItem = resp.data;
          //store child ids in array so they can be referenced by ID if needed
          //store response keyed by child ID
          //const childList = helpers.arrayToObject(childItems, "identifier");
          // const childList = helpers.searchTermKeyed(childItems, "identifier");
          var dispatcher = function dispatcher(dispatch) {
            dispatch(submissionResponse("child", childItem.identifier, null, false));
            dispatch(setChild(childItem, childItem.identifier, false));
            dispatch(statusUpdater("COMPLETE"));
            callback(resp);
            // return Promise.resolve();
          };
          return dispatch(dispatcher);
        }
      }).catch(function (resp) {
        dispatch(submissionResponse("child", resp, null, true));
        dispatch(statusUpdater("ERROR"));
        callback(resp);
        // return Promise.resolve();
      });
    };
  }

  //this was removed by the RCDS team...not sure if it is coming back.
  // Action Type
  // export const GET_CHILD_STORY_BY_ID = "RECEIVE_CHILD_STORY_BY_ID";
  // Action Creator
  function getChildStoryById(data) {
    // console.log("child Id: ", data);
    return function (dispatch) {
      dispatch(statusUpdater("EDITING"));
      dispatch(submissionRequest("story", data));
      return _appRequest2.default.getChildStory(data).then(function (resp) {
        if (resp.success != true || !resp.success) {
          // console.log("response from action error: ", resp);
          return Promise.reject(resp);
        } else {
          // console.log("childList by Id:", resp.data);
          var dispatcher = function dispatcher() {
            return function (dispatch) {
              dispatch(submissionResponse("story", resp.data, null, false));
              dispatch(statusUpdater("COMPLETE"));
              return Promise.resolve();
            };
          };
          return dispatch(dispatcher());
        }
      }).catch(function (resp) {
        // console.log("got here:", resp);
        dispatch(submissionResponse("story", resp, null, true));
        dispatch(statusUpdater("ERROR"));
        return Promise.resolve();
      });
    };
  }
  var GET_CONTENT = exports.GET_CONTENT = "GET_CONTENT";
  function getContent() {
    return;
  }
  var GET_DESCRIPTORS = exports.GET_DESCRIPTORS = "GET_DESCRIPTORS";
  function getDescriptors() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

    return function (dispatch) {
      dispatch(statusUpdater("EDITING"));
      dispatch(submissionRequest("descriptors", ''));
      return _appRequest2.default.getChildDescriptors().then(function (resp) {
        if (resp.success != true || !resp.success) {
          console.log("response from action descriptors error: ", resp);
          return Promise.reject(resp);
        } else {
          console.log("response from action descriptors: ", resp);
          // console.log("childList by Id:", resp.data);
          var dispatcher = function dispatcher() {
            return function (dispatch) {
              dispatch(submissionResponse("descriptors", resp.data, null, false));
              dispatch(setDescriptors(resp.data, false));
              callback(resp);
              return Promise.resolve();
            };
          };
          return dispatch(dispatcher());
        }
      }).catch(function (resp) {
        // console.log("got here:", resp);
        dispatch(submissionResponse("descriptors", resp, null, true));
        dispatch(statusUpdater("ERROR"));
        return Promise.resolve();
      });
      //stubbed out for restful endpoint
    };
  }
});